import { render, staticRenderFns } from "./Recipient.repeat.daily.vue?vue&type=template&id=c996f1be&"
import script from "./Recipient.repeat.daily.vue?vue&type=script&lang=js&"
export * from "./Recipient.repeat.daily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports